import React, { useRef } from "react";
import SkeletonTable from "../Skeleton/SkeletonTable";
import { Singleton } from "helper/tools";
import { format } from "date-fns";

export default function AsociadosKPITableSmall2({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  return (
    <table
      className="table table-borderless datable sortable table-hover"
      style={{ tableLayout: "fixed" }}
    >
      <thead className="table-light" style={{ textAlign: "center" }}>
        <tr ref={theadRef}>
          {/*<th
            rowSpan={2}
            scope="col"
            data-column="asociado.id"
            style={{ width: "90px", verticalAlign: "middle" }}
            onClick={(event) => handleSort(event)}
          >
            Id
          </th>*/}

          <th
            scope="col"
            data-column="fechaIngreso"
            style={{
              verticalAlign: "middle",
              width: "120px",
              textAlign: "center",
            }}
          >
            Fecha Ingreso
          </th>

          <th
            rowSpan={2}
            scope="col"
            data-column="asociadoNombre"
            style={{ verticalAlign: "middle", width: "99%" }}
          >
            Nombre
          </th>

          <th
            rowSpan={2}
            scope="col"
            data-column="total"
            style={{ width: "120px", verticalAlign: "middle" }}
          >
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        {isLoading && <SkeletonTable columnCount={9} rowCount={6} />}

        {!isLoading &&
          items?.length > 0 &&
          items?.map((data, index) => {
            const { asociadoNombre, total, asociadoFechaIngreso } = data;

            const totalA = Singleton.getInstance().format(total);

            const fechaIngreso = format(asociadoFechaIngreso, "yyyy-MM-dd");

            return (
              <tr key={index}>
                <th
                  scope="row"
                  style={{
                    verticalAlign: "middle",
                    justifyItems: "center",
                    textAlign: "left",
                  }}
                >
                  {fechaIngreso}
                </th>
                <td
                  scope="row"
                  style={{
                    verticalAlign: "middle",
                    justifyItems: "center",
                    textAlign: "left",
                  }}
                >
                  {asociadoNombre}
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    justifyItems: "center",
                    textAlign: "right",
                  }}
                >
                  {totalA}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}
